var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#DFCBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_18880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 23V22.1215H11.0588V21.3421H9.82353V20.4636H11.0588V19.6842H9V18.8057H11.3439C11.5413 18.8057 11.7068 18.8654 11.8404 18.9849C11.9739 19.1044 12.0407 19.2525 12.0407 19.4291V20.3077C12.0407 20.4843 11.9739 20.6324 11.8404 20.7519C11.7068 20.8714 11.5413 20.9312 11.3439 20.9312C11.5413 20.9312 11.7068 20.9909 11.8404 21.1104C11.9739 21.2299 12.0407 21.378 12.0407 21.5546V22.3765C12.0407 22.5532 11.9739 22.7012 11.8404 22.8207C11.7068 22.9402 11.5413 23 11.3439 23H9ZM9 18.0972V16.1842C9 16.0076 9.06678 15.8595 9.20034 15.74C9.33391 15.6205 9.4994 15.5607 9.69683 15.5607H11.0588V14.7814H9V13.9028H11.3439C11.5413 13.9028 11.7068 13.9626 11.8404 14.0821C11.9739 14.2016 12.0407 14.3497 12.0407 14.5263V15.8158C12.0407 15.9924 11.9739 16.1405 11.8404 16.26C11.7068 16.3795 11.5413 16.4393 11.3439 16.4393H9.9819V17.2186H12.0407V18.0972H9ZM10.2353 13.1943V9.87854H9V9H11.2172V13.1943H10.2353ZM13.9206 20.8504V20.0144H23V20.8504H13.9206ZM13.9206 16.3882V15.5522H23V16.3882H13.9206ZM13.9206 11.9261V11.0901H23V11.9261H13.9206Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_18880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.4a1c45e60e2ab187a9f90c0eb6c5e53f.svg";
export { ForwardRef as ReactComponent };